/*
 * Palo Alto Theme
 *
 * Use this file to add custom Javascript to Palo Alto. Keeping your custom
 * Javascript in this file will make it easier to update Palo Alto. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function() {
    // Add custom code below this line

    // Initialize all functionalities after DOM is loaded
    document.addEventListener('DOMContentLoaded', () => {

        
        // ---- B2B Flyer PDP-only guard (ONLY runs on /products/b2b-flyer) ----
// ---- B2B Flyer PDP-only guard (SYNC block first, then async decide) ----
(() => {
  // matches: /products/b2b-flyer and /de/products/b2b-flyer etc.
  if (!/^\/([a-z]{2}\/)?products\/b2b-flyer(\/|$)/i.test(window.location.pathname)) return;

  const MAX = 50;

  const getForm = () =>
    document.querySelector('form.product__form[action*="/cart/add"][data-limit-handle="b2b-flyer"]');

  const getVariantId = (form) => String(form.querySelector('input[name="id"]')?.value || "");
  const getQtyInput = (form) => form.querySelector('input[name="quantity"]');
  const readQty = (form) => {
    const n = parseInt(getQtyInput(form)?.value || "1", 10);
    return Number.isFinite(n) && n > 0 ? n : 1;
  };
  const setQty = (form, qty) => {
    const el = getQtyInput(form);
    if (el) el.value = String(qty);
  };

  const getCart = async () => {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    return r.json();
  };

  const reTriggerThemeFlow = (form, clickedSubmitBtn) => {
    form.dataset.b2bFlyerBypass = "1";

    // Prefer clicking the same submit button the user clicked (theme listens to click)
    if (clickedSubmitBtn) {
      clickedSubmitBtn.click();
      return;
    }

    // fallback: try any submit button
    const btn = form.querySelector('button[type="submit"], [type="submit"]');
    if (btn) btn.click();
    else if (typeof form.requestSubmit === "function") form.requestSubmit();
    else form.submit();
  };

  const intercept = (e) => {
    const form = getForm();
    if (!form) return;

    // let our re-trigger pass through once
    if (form.dataset.b2bFlyerBypass === "1") {
      form.dataset.b2bFlyerBypass = "0";
      return;
    }

    const variantId = getVariantId(form);
    if (!variantId) return;

    // IMPORTANT: block immediately so theme cannot start AJAX add
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    const clickedSubmitBtn =
      e.type === "click"
        ? e.target?.closest?.('button[type="submit"], [type="submit"]')
        : null;

    // async decision after we've already blocked the event
    (async () => {
      let cart;
      try {
        cart = await getCart();
      } catch (_) {
        // If cart fails, don't hard-break ATC; allow normal flow
        reTriggerThemeFlow(form, clickedSubmitBtn);
        return;
      }

      const item = cart.items?.find((it) => String(it.variant_id) === variantId);
      const already = item ? item.quantity : 0;
      const remaining = MAX - already;

      if (remaining <= 0) {
        alert(`Max ${MAX} allowed per order for this item.`);
        return; // stay blocked
      }

      const requested = readQty(form);
      if (requested > remaining) {
        setQty(form, remaining);
        alert(`Only ${remaining} more can be added (max ${MAX}). Quantity adjusted.`);
      }

      // allowed -> let theme do its normal add (AJAX + drawer + events)
      reTriggerThemeFlow(form, clickedSubmitBtn);
    })();
  };

  const attach = () => {
    const form = getForm();
    if (!form) return;
    if (form.dataset.b2bFlyerGuardInit === "1") return;
    form.dataset.b2bFlyerGuardInit = "1";

    // Capture phase = before Palo Alto handlers
    form.addEventListener("submit", intercept, true);

    // Also capture submit-button clicks (this is what Palo Alto often uses)
    form.addEventListener(
      "click",
      (e) => {
        const submitBtn = e.target?.closest?.('button[type="submit"], [type="submit"]');
        if (submitBtn) intercept(e);
      },
      true
    );
  };

  attach();
  document.addEventListener("theme:section:load", attach);
})();
// ---- end guard ----



        // Bundle Product Checkout Function
        const bundleAddToCartProduct = (currentThis, dynamicData) => {
            // Adds bundle products to the cart and redirects to checkout
            $.ajax({
                url: "/cart/add.js",
                type: "POST",
                data: {
                    items: dynamicData
                },
                dataType: "json",
                success: function(data) {
                    currentThis.removeClass('untouchable');
                    window.location.replace("/checkout");
                },
                error: function(jqXHR) {
                    currentThis.removeClass('untouchable');
                    if (jqXHR.status === 400) {
                        alert(jqXHR.responseJSON.message);
                    }
                    if (jqXHR.status === 422) {
                        alert(jqXHR.responseJSON.description);
                    }
                }
            });
        };

        // Initialize Bundle Product Checkout Button
        $('#lp_addToCart_btn, #lp_addToCart_btn_2').click(function() {
            const lpvariantId = $(this).attr('var-id');
            const quantity = 1;
            const updateItems = [];
            const currentThis = $(this);
            updateItems.push({
                "id": lpvariantId,
                "quantity": quantity
            });
            $.ajax({
                type: "POST",
                url: '/cart/clear.js',
                success: function() {
                    bundleAddToCartProduct(currentThis, updateItems);
                    currentThis.addClass('is-loading');
                },
                dataType: 'json'
            });
        });

        // Cart Progress Bar Fix for Subscription Products
        const handleCartAdded = () => {
            // Adjusts the cart drawer's progress bar and messages when subscription products are added
            const sellingPlanSubscriptionElement = document.querySelector('.cart-drawer__items .cart__item__selling-plan-subscription');
            const cartMessageElement = document.querySelector('.cart-drawer__message');

            if (sellingPlanSubscriptionElement && cartMessageElement && !cartMessageElement.classList.contains('is-success')) {
                cartMessageElement.classList.add('is-success');
                const defaultMessage = document.querySelector('.cart__message__default');
                if (defaultMessage) {
                    defaultMessage.classList.add('is-hidden');
                }

                const progressElements = document.querySelectorAll('.cart__message__progress');
                progressElements.forEach(progressElement => {
                    progressElement.classList.add('is-hidden');
                    progressElement.setAttribute('value', '100');
                    progressElement.setAttribute('max', '100');
                    progressElement.style.setProperty('--progress-width', '100%');
                });
            }

            // CartDrawer Upgrade To Subscription Start
            const subscriptionButtons = document.querySelectorAll('.subscription-button');
            subscriptionButtons.forEach((button) => {
                if (button.getAttribute('data-click-added') === null) {
                    button.setAttribute('data-click-added', '');
                    button.addEventListener('click', () => {
                        const optionsContainer = button.nextElementSibling;
                        const selectElement = optionsContainer.querySelector('.subscription-select');
                        optionsContainer.style.display = 'block';
                        selectElement.style.display = 'block';
                        button.style.display = 'none';
                        button.classList.add('is-loading');
                        selectElement.showPicker();
                    });
                }
            });

            const subscriptionSelects = document.querySelectorAll('.subscription-select');
            subscriptionSelects.forEach((select) => {
                select.setAttribute('data-initial-value', select.value);

                select.addEventListener('change', function() {
                    const initialValue = this.getAttribute('data-initial-value');

                    if (this.value !== initialValue) {
                        const cartItemID = this.closest('.upgrade-to-subscription').getAttribute('data-line-item-id');
                        const selectedPlanID = this.value;
                        const variantId = this.querySelector('option:checked').getAttribute('data-variant-id');

                        const updateCart = (formData, callback) => {
                            $.ajax({
                                url: '/cart/change.js',
                                type: 'POST',
                                data: formData,
                                dataType: 'json',
                                success: function(data) {
                                    if (callback) callback();
                                },
                                error: function(jqXHR) {
                                    console.error('Error updating cart:', jqXHR.responseJSON);
                                }
                            });
                        };

                        const addToCart = (variantId, quantity, sellingPlanId) => {
                            const items = [{
                                id: variantId,
                                quantity: quantity,
                                selling_plan: sellingPlanId
                            }];

                            $.ajax({
                                url: '/cart/add.js',
                                type: 'POST',
                                data: {
                                    items: items
                                },
                                dataType: 'json',
                                success: function() {
                                    document.dispatchEvent(new CustomEvent('updateCartDrawer'));
                                },
                                error: function(jqXHR) {
                                    console.error('Error adding item to cart:', jqXHR.responseJSON);
                                }
                            });
                        };

                        updateCart({
                            id: cartItemID,
                            quantity: 0
                        }, () => {
                            addToCart(variantId, 1, selectedPlanID);
                        });

                        this.style.display = 'none';
                        const subscriptionButton = this.closest('.upgrade-to-subscription').querySelector('.subscription-button');
                        if (subscriptionButton) {
                            subscriptionButton.style.display = 'block';
                        }
                        this.closest('.subscription-options-container').style.display = 'none';

                        this.setAttribute('data-initial-value', this.value);
                    }
                });
            });

            // CartDrawer Upgrade To Subscription End
        };

        document.addEventListener('theme:cart:added', handleCartAdded);
        document.addEventListener('theme:cart:open', handleCartAdded);

        // Read More Methods
        const header = document.querySelector('#SiteHeader');

        const lockScrollReadMore = () => {
            // Locks the background scroll when an overlay is active
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            if (header) {
                header.style.paddingRight = `${scrollbarWidth}px`;
            }
            document.body.setAttribute('data-scroll-lock-locked', 'true');
            document.documentElement.setAttribute('data-scroll-lock-locked', '');
        };

        const unlockScrollReadMore = () => {
            // Unlocks the background scroll when an overlay is closed
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            if (header) {
                header.style.paddingRight = '';
            }
            document.body.removeAttribute('data-scroll-lock-locked');
            document.documentElement.removeAttribute('data-scroll-lock-locked');
        };

        // Upsell Cart Methods
        const lockScrollUpsell = () => {
            // Locks scroll when upsell overlay is open
            const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = `${scrollbarWidth}px`;
            document.body.setAttribute('data-scroll-lock-locked', 'true');
            document.documentElement.setAttribute('data-scroll-lock-locked', '');
            document.body.classList.add('js-drawer-open');
        };

        const unlockScrollUpsell = () => {
            // Unlocks scroll when upsell overlay is closed
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
            document.body.removeAttribute('data-scroll-lock-locked');
            document.documentElement.removeAttribute('data-scroll-lock-locked');
            document.body.classList.remove('js-drawer-open');
        };

        const getBundleProductData = (dataIndex, upsellCase, addToCartButton) => {
            let bundleProductItem = document.querySelector(`.bundle_product_options .bundle_prod_item[data-index="${dataIndex}"]`);
            
            if (!bundleProductItem) {
                bundleProductItem = document.querySelector('.bundle_product_options .bundle_prod_item[data-index="0"]');
            }
            
            if (!bundleProductItem) {
                const unitQuantityItem = document.querySelector(`.subscription-widget__selectors-unit-quantity .subscription-widget__selectors-label[data-index="${dataIndex}"]`);
                
                if (unitQuantityItem) {
                    const dataId = unitQuantityItem.getAttribute('data-variant-id');
                    const quantity = unitQuantityItem.getAttribute('data-quantity') || '1';
                    
                    if (upsellCase === 'upsell_enabled') {
                        storeOriginalFormInputsUpsell();
                        const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
                        updateFormInputs(upsellForm, dataId, '', parseInt(quantity));
                        addToCartButton.setAttribute('data-upsell-drawer-click', 'true');
                        addToCartButton.click();
                        restoreOriginalFormInputsUpsell();
                    } else {
                        addToCart(dataId, parseInt(quantity), null, addToCartButton);
                    }
                    return;
                }
            }
            
            if (bundleProductItem) {
                const dataId = bundleProductItem.getAttribute('data-id');
                const sellingPlanSelect = bundleProductItem.querySelector('.product-single__selling_plans');
                const sellingPlanId = sellingPlanSelect && sellingPlanSelect.selectedOptions.length > 0 ? sellingPlanSelect.selectedOptions[0].getAttribute('data-selling-plan-id') : null;
                
                if (upsellCase === 'upsell_enabled') {
                    storeOriginalFormInputsUpsell();
                    const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
                    updateFormInputs(upsellForm, dataId, sellingPlanId, 1); // Always quantity 1 for bundle products
                    addToCartButton.setAttribute('data-upsell-drawer-click', 'true');
                    addToCartButton.click();
                    restoreOriginalFormInputsUpsell();
                } else {
                    addToCart(dataId, 1, sellingPlanId, addToCartButton);
                }
            } else {
                console.log('WARNING: No product item found at all!');
            }
        };

        // Adds the upsell product to the cart via AJAX
        const addToCart = (variantId, quantity, sellingPlanId, addToCartButton) => {
            const item = {
                id: variantId,
                quantity: quantity
            };

            if (sellingPlanId) {
                item.selling_plan = sellingPlanId;
            }

            $.ajax({
                url: '/cart/add.js',
                type: 'POST',
                data: {
                    items: [item]
                },
                dataType: 'json',
                success: () => {
                    addToCartButton.setAttribute('data-upsell-drawer-click', 'true');
                    addToCartButton.click();
                },
                error: (jqXHR) => {
                    console.error('Error adding item to cart:', jqXHR.responseJSON);
                }
            });
        };

        // Updates form inputs temporarily to handle upsell additions
        const updateFormInputsUpsell = (id, sellingPlanId) => {
            const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
            const idInput = upsellForm.querySelector('input[name="id"][data-product-select]');
            if (idInput) {
                idInput.value = id;
            }
            const sellingPlanInput = upsellForm.querySelector('input[name="selling_plan"]');
            if (!sellingPlanId) {
                if (sellingPlanInput) {
                    sellingPlanInput.remove();
                }
            } else {
                if (sellingPlanInput) {
                    sellingPlanInput.value = sellingPlanId;
                } else {
                    const newSellingPlanInput = document.createElement('input');
                    newSellingPlanInput.type = 'hidden';
                    newSellingPlanInput.name = 'selling_plan';
                    newSellingPlanInput.value = sellingPlanId;
                    upsellForm.appendChild(newSellingPlanInput);
                }
            }
        };

        const storeOriginalFormInputsUpsell = () => {
            const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
            const idInput = upsellForm.querySelector('input[name="id"][data-product-select]');
            const sellingPlanInput = upsellForm.querySelector('input[name="selling_plan"]');
            const quantityInput = upsellForm.querySelector('input[name="quantity"]');
        
            upsellForm.setAttribute('data-original-id', idInput ? idInput.value : '');
            upsellForm.setAttribute('data-original-selling-plan', sellingPlanInput ? sellingPlanInput.value : '');
            upsellForm.setAttribute('data-original-quantity', quantityInput ? quantityInput.value : '1');
        };
        
        const restoreOriginalFormInputsUpsell = () => {
            const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');
            const originalId = upsellForm.getAttribute('data-original-id');
            const originalSellingPlan = upsellForm.getAttribute('data-original-selling-plan');
            const originalQuantity = upsellForm.getAttribute('data-original-quantity');
        
            const idInput = upsellForm.querySelector('input[name="id"][data-product-select]');
            if (idInput) {
                idInput.value = originalId;
            }
        
            const quantityInput = upsellForm.querySelector('input[name="quantity"]');
            if (quantityInput) {
                quantityInput.value = originalQuantity || '1';
            }
        
            const sellingPlanInput = upsellForm.querySelector('input[name="selling_plan"]');
            if (!originalSellingPlan) {
                if (sellingPlanInput) {
                    sellingPlanInput.remove();
                }
            } else {
                if (sellingPlanInput) {
                    sellingPlanInput.value = originalSellingPlan;
                } else {
                    const newSellingPlanInput = document.createElement('input');
                    newSellingPlanInput.type = 'hidden';
                    newSellingPlanInput.name = 'selling_plan';
                    newSellingPlanInput.value = originalSellingPlan;
                    upsellForm.appendChild(newSellingPlanInput);
                }
            }
        };

        // Subscription Selector Methods
        const toggleClass = (element, className, condition) => {
            // Utility function to add/remove classes
            condition ? element.classList.add(className) : element.classList.remove(className);
        };

        const updateAttribute = (element, attributeName, value) => {
            // Updates an attribute of an element
            element.setAttribute(attributeName, value);
        };

        const updateFormInputs = (form, id, sellingPlanId, quantity = 1) => {
            // Updates hidden form inputs for variant and selling plan
            const idInput = form.querySelector('input[name="id"][data-product-select]');
            if (idInput) {
                idInput.value = id;
            }
        
            // Handle quantity input for unit products
            let quantityInput = form.querySelector('input[name="quantity"]');
            if (quantityInput) {
                quantityInput.value = quantity;
            } else if (quantity > 1) {
                // Create quantity input if it doesn't exist and quantity > 1
                quantityInput = document.createElement('input');
                quantityInput.type = 'hidden';
                quantityInput.name = 'quantity';
                quantityInput.value = quantity;
                form.appendChild(quantityInput);
            }
        
            const sellingPlanInput = form.querySelector('input[name="selling_plan"]');
            if (!sellingPlanId) {
                if (sellingPlanInput) {
                    sellingPlanInput.remove();
                }
            } else {
                if (sellingPlanInput) {
                    sellingPlanInput.value = sellingPlanId;
                } else {
                    const newSellingPlanInput = document.createElement('input');
                    newSellingPlanInput.type = 'hidden';
                    newSellingPlanInput.name = 'selling_plan';
                    newSellingPlanInput.value = sellingPlanId;
                    form.appendChild(newSellingPlanInput);
                }
            }
        };

        const toggleSaveUpToMessage = (element, showSaveUpElement) => {
            // Toggles the display of "Save Up To" messages
            const saveUpToElement = element.closest('form').querySelector('.subscription-widget__item-save-up-to');
            const savingPriceElement = element.closest('form').querySelector('.subscription-widget__subscription-saving-price');

            if (showSaveUpElement) {
                saveUpToElement.classList.remove('subscription-widget__hidden');
                savingPriceElement.classList.add('subscription-widget__hidden');
              
            } else {              
                saveUpToElement.classList.add('subscription-widget__hidden');
                savingPriceElement.classList.remove('subscription-widget__hidden');
            }
        };

        const updatePrice = (element, price) => {
            // Updates displayed prices
            const priceSpan = element.querySelector('.subscription-widget__item-price');
            const addToCartPriceElement = element.closest('form').querySelector('.product__submit__buttons button span[data-product-price]');

            if (priceSpan && addToCartPriceElement) {
                priceSpan.textContent = price;
                addToCartPriceElement.textContent = price;
            }
        };

        const getUnitServingPrice = (totalPriceString, quantity, basePriceString) => {
            const regex = /([^\d.,]*\s?[^\d]*)?([\d.,]+)([^\d]*)/;
            const match = totalPriceString.match(regex);
            const baseMatch = basePriceString.match(regex);
        
            if (match && baseMatch) {
                let currencySymbol = match[1];
                let totalPrice = match[2];
                let basePrice = baseMatch[2];
                const currencySymbolAfter = match[3];
        
                if (currencySymbolAfter) {
                    currencySymbol += currencySymbolAfter;
                }
        
                const lastCommaIndex = totalPrice.lastIndexOf(',');
                const lastPeriodIndex = totalPrice.lastIndexOf('.');
        
                let thousandsSeparator = ',';
                let decimalSeparator = '.';
                if (lastCommaIndex > lastPeriodIndex) {
                    thousandsSeparator = '.';
                    decimalSeparator = ',';
                }
        
                totalPrice = totalPrice.split(thousandsSeparator).join('');
                totalPrice = totalPrice.replace(decimalSeparator, '.');
                totalPrice = parseFloat(totalPrice);
        
                basePrice = basePrice.split(thousandsSeparator).join('');
                basePrice = basePrice.replace(decimalSeparator, '.');
                basePrice = parseFloat(basePrice);
        
                // Calculate per-unit price for multi-unit purchases
                const perUnitPrice = totalPrice / quantity;
                
                // Calculate serving price (assuming 30 servings per unit)
                const servingPrice = perUnitPrice / 30;
        
                return `${currencySymbol}${servingPrice.toFixed(2)}`;
            } else {
                console.error('Invalid price string');
                return totalPriceString;
            }
        };

        const updateServingPrice = (element) => {
            // Updates serving price based on the subscription plan
            const priceString = element.getAttribute('data-price');
            const planName = element.getAttribute('data-index');
            const isUnitQuantity = element.closest('.subscription-widget__selectors-unit-quantity');
            
            let newPrice;
            if (isUnitQuantity) {
                // For unit quantities, calculate per-unit price
                const quantity = parseInt(element.getAttribute('data-quantity') || '1');
                const basePrice = element.closest('.subscription-widget').querySelector('.subscription-widget__item-onetime .subscription-widget__item-price').textContent;
                newPrice = getUnitServingPrice(priceString, quantity, basePrice);
            } else {
                newPrice = getServingPrice(priceString, planName);
            }
            
            const priceClass = (!isUnitQuantity && planName > 0 && planName < 4) ? 'subscribe' : 'one-time';
        
            const servingPriceElement = element.closest('.subscription-widget').querySelector(`.subscription-widget__serving-price.${priceClass}`);
            if (servingPriceElement) {
                servingPriceElement.textContent = newPrice;
            } else {
                console.error('Could not find .subscription-widget__serving-price element');
            }
        };

        const updateFormDataIndex = (form, dataIndex) => {
            // Updates form data attributes
            form.setAttribute('data-selected-item-index', dataIndex);
        };

        const getServingPrice = (priceString, planName) => {
            // const regex = /([^\d.,]*)([\d.,]+)([^\d]*)/;
            const regex = /([^\d.,]*\s?[^\d]*)?([\d.,]+)([^\d]*)/;
            const match = priceString.match(regex);

            if (match) {
                let currencySymbol = match[1];
                let price = match[2];
                const currencySymbolAfter = match[3];

                if (currencySymbolAfter) {
                    currencySymbol += currencySymbolAfter;
                }

                const lastCommaIndex = price.lastIndexOf(',');
                const lastPeriodIndex = price.lastIndexOf('.');

                let thousandsSeparator = ',';
                let decimalSeparator = '.';
                if (lastCommaIndex > lastPeriodIndex) {
                    thousandsSeparator = '.';
                    decimalSeparator = ',';
                }

                price = price.split(thousandsSeparator).join('');
                price = price.replace(decimalSeparator, '.');
                price = parseFloat(price);

                switch (planName) {
                    case '0':
                    case '3':
                        price /= 30;
                        break;
                    case '2':
                    case '4':
                        price /= 90;
                        break;
                    case '5':
                        price /= 180;
                        break;
                    case '1':
                    case '6':
                        price /= 365;
                        break;
                    default:
                        console.error('Invalid plan name');
                        return priceString;
                }

                return `${currencySymbol}${price.toFixed(2)}`;
            } else {
                console.error('Invalid price string');
                return priceString;
            }
        };

        const onSubscriptionItemClick = (item, subscriptionItems, container) => {
            subscriptionItems.forEach((i) => {
                toggleClass(i, 'selected', i === item);
                updateAttribute(i.querySelector('button'), 'aria-expanded', i === item ? 'true' : 'false');
            });

            const form = item.closest('form[action*="/cart/add"]');
            if (item.querySelector('.subscription-widget__item-onetime')) {
                toggleSaveUpToMessage(item, true);
                if (item.querySelector('.subscription-widget__selectors')) {
                    const selectedItem = item.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');
                    selectedItem ? selectedItem.click() : clickOneJarLabel(container);
                } else {
                    if (form) {
                        updateFormInputs(form, item.querySelector('label').getAttribute('variant-id'), '');
                        updatePrice(item, item.querySelector('.subscription-widget__item-price').textContent);
                        updateFormDataIndex(form, "0");
                    }
                }
            } else if (item.querySelector('.subscription-widget__item-subscribe')) {
                toggleSaveUpToMessage(item, false);
                const selectedItem = item.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');
                selectedItem ? selectedItem.click() : clickOneMonthLabel(container);
            }
        };

        const onSubscriptionLabelClick = (label) => {
            const radioGroupWrapper = label.parentElement;
            radioGroupWrapper.querySelectorAll('.subscription-widget__selectors-radio-subscriptions').forEach((radio) => {
                radio.removeAttribute('data-checked');
            });

            const radioSubscriptions = label.querySelector('.subscription-widget__selectors-radio-subscriptions');
            radioSubscriptions.setAttribute('data-checked', '');

            const form = label.closest('form[action*="/cart/add"]');
            const itemWrap = label.closest('.subscription-widget__item-wrap');
            if (form && itemWrap) {
                const flavourSelectorWrapper = window.document.querySelector('.product__selectors .selector-wrapper[data-option-position="1"]');

                let selectedIndex = 0;
                if (flavourSelectorWrapper) {
                    const selectedOption = flavourSelectorWrapper.querySelector('input[type="radio"]:checked');
                    if (selectedOption) {
                        const radioButtons = flavourSelectorWrapper.querySelectorAll('input[type="radio"]');
                        radioButtons.forEach((radio, index) => {
                            if (radio.checked) {
                                selectedIndex = index;
                            }
                        });
                    }
                }

                const dataAttributes = JSON.parse(label.getAttribute('data-variants-all'));
                const dataVariantId = dataAttributes[selectedIndex].variant_id;
                const dataSellingPlanId = dataAttributes[selectedIndex].selling_plan_id;
                const dataQuantity = label.getAttribute('data-quantity');
                const quantity = dataQuantity !== null ? dataQuantity : 1;
                updateFormInputs(form, dataVariantId, dataSellingPlanId, quantity);
                updateServingPrice(label);
                updatePrice(itemWrap, label.getAttribute('data-price'));
                updateFormDataIndex(form, label.getAttribute('data-index'));

                const frequencyText = itemWrap.querySelector('.subscription-widget__selectors-info-items-fequency');
                if (frequencyText) {
                    frequencyText.innerHTML = label.getAttribute('data-plan-desc');
                }
            }
        };

        const addClickListeners = (container, selector, handler) => {
            // Adds event listeners to multiple elements
            const elements = container.querySelectorAll(selector);
            elements.forEach((element) => {
                if (!element.hasAttribute('data-click-listener-added')) {
                    element.addEventListener('click', handler);
                    element.setAttribute('data-click-listener-added', 'true');
                }
            });
        };

        const initSubscriptionWidget = (widgetId) => {
            // Initializes subscription widgets on the page
            const widgetContainers = document.querySelectorAll(`.subscription-widget[data-widget-id="${widgetId}"]`);
            widgetContainers.forEach((widgetContainer) => {
                if (!widgetContainer.getAttribute('data-widget-initiated')) {

                    addClickListeners(widgetContainer, '.subscription-widget__item', (event) => {
                        const item = event.currentTarget;
                        const subscriptionItems = widgetContainer.querySelectorAll('.subscription-widget__item');
                        onSubscriptionItemClick(item, subscriptionItems, widgetContainer);
                    });

                    addClickListeners(widgetContainer, '.subscription-widget__selectors-label', (event) => {
                        event.stopPropagation();
                        onSubscriptionLabelClick(event.currentTarget);
                    });

                    clickSubscriptionPlan(widgetContainer);
                    clickOneJarLabel(widgetContainer);
                    clickOneMonthLabel(widgetContainer);

                    setupRadioChangeListener(widgetContainer);

                    widgetContainer.setAttribute('data-widget-initiated', 'true');
                }
            });
        };

        const setupRadioChangeListener = (widgetContainer) => {
            // Listens for changes in the product options to update the subscription widget
            const optionWrapper = window.document.querySelector('.product__selectors [data-option-position="1"]');
            if (optionWrapper) {
                const radioButtons = optionWrapper.querySelectorAll('input[type="radio"]');

                radioButtons.forEach((radio) => {
                    radio.addEventListener('change', function() {
                        const openedRadioGroup = document.querySelector('.subscription-widget__item.selected');
                        if (openedRadioGroup) {
                            const checkedElement = openedRadioGroup.querySelector('.subscription-widget__selectors-radio-subscriptions[data-checked]');

                            if (checkedElement) {
                                checkedElement.closest('label').click();
                            } else {
                                console.log('No element with data-checked attribute found.');
                            }
                        } else {
                            console.log('No opened subscription-widget__selectors-radiogroup found.');
                        }
                    });
                });
            } else {
                console.log('No element found with data-option-position="1".');
            }
        };

        const clickSubscriptionPlan = (widgetContainer) => {
            const subscribeButton = widgetContainer.querySelector('.subscription-widget__item-subscribe');
            if (subscribeButton) {
                subscribeButton.click();
            }
            
            setTimeout(() => {
                const unitQuantitySelector = widgetContainer.querySelector('.subscription-widget__selectors-unit-quantity');
                if (!unitQuantitySelector) {
                    clickOneMonthLabel(widgetContainer);
                }
            }, 100);
        };

        const clickOneMonthLabel = (widgetContainer) => {
            const unitQuantitySelector = widgetContainer.querySelector('.subscription-widget__selectors-unit-quantity');
            if (unitQuantitySelector) {
                const monthlyLabel = widgetContainer.querySelector('.subscription-widget__selectors-label-subscriptions--2');
                if (monthlyLabel) {
                    monthlyLabel.click();
                }
            } else {
                const oneMonthLabel = widgetContainer.querySelector('.subscription-widget__selectors-label[data-index="3"]');
                if (oneMonthLabel) {
                    oneMonthLabel.click();
                }
            }
        };

        const clickOneJarLabel = (widgetContainer) => {
            // Automatically selects the one-time purchase option
            const unitQuantitySelector = widgetContainer.querySelector('.subscription-widget__selectors-unit-quantity');
            if (unitQuantitySelector) {
                // For unit quantities, select the 1 unit option
                const oneUnitLabel = widgetContainer.querySelector('.subscription-widget__selectors-label[data-quantity="1"]');
                if (oneUnitLabel) {
                    oneUnitLabel.click();
                }
            } else {
                // Original functionality for bundle jars
                const oneJarLabel = widgetContainer.querySelector('.subscription-widget__selectors-label[data-index="0"]');
                if (oneJarLabel) {
                    oneJarLabel.click();
                }
            }
        };

        // Free Gift / Double Progress Bar initialization
        let isFirstLoad = true;
        if (window.themeSettings && window.themeSettings.freeGiftData) {
            const data = window.themeSettings.freeGiftData;
            const freeShippingLimit = data.freeShippingLimit || 0;
            const freeGiftLimit = data.freeGiftLimit || 0;
            const currencyEnabled = data.currencyEnabled;
            const currencyRate =
                window.Shopify && window.Shopify.currency && window.Shopify.currency.rate
                    ? parseFloat(window.Shopify.currency.rate)
                    : 1;
            const moneyFormat = currencyEnabled
                ? theme.moneyWithCurrencyFormat
                : theme.moneyFormat;
            const freeGiftMessage = data.freeGiftMessage;
            const shippingGiftMessage = data.shippingGiftMessage;
            const shippingMessage = data.freeShippingMessage;
            const freeGiftLimitCurrency = freeGiftLimit * 100;
            const freeGiftProductHandle = data.freeGiftProductHandle;
            const freeGiftQuantity = 1;
            const freeGiftVariantId = data.freeGiftVariantId;
            let cartTotalPrice = window.themeSettings.cartTotalPrice || 0;
            let isAddingFreeGift = false;

            const updateCartData = () => {
                fetch('/cart.js')
                    .then((response) => response.json())
                    .then((cart) => {
                        cartTotalPrice = cart.total_price;
                        const progressBarElement = document.querySelector('.cart-drawer__message-new.cart__message-new');
                        const hasHolidayBox = cart.items.some((item) => item.product_title === "Gift Box");
                        if (cartTotalPrice <= 0 || hasHolidayBox) {
                            if (progressBarElement) {
                                progressBarElement.classList.add('is-hidden');
                            }
                        } else {
                            if (progressBarElement) {
                                progressBarElement.classList.remove('is-hidden');
                            }
                        }

                        if (isFirstLoad && !window.location.href.includes('/cart')) {
                            isFirstLoad = false;
                            return;
                        } else {
                            updateProgressBarsWithCart(cart);
                            checkGiftEligibilityWithCart(cart);
                        }

                    })
                    .catch((error) => {
                        console.error('Error fetching cart data:', error);
                    });
            };

            const updateProgressBarsWithCart = (cart) => {
                // Helper function to decode HTML entities
                const decodeHTMLEntities = (text) => {
                    const tempElement = document.createElement('textarea');
                    tempElement.innerHTML = text;
                    return tempElement.value;
                };
            
                // Updates the progress bars based on cart total
                const cartTotalPriceCents = cart.total_price;
                const limitShippingCents = freeShippingLimit * 100 * currencyRate;
                const limitGiftCents = freeGiftLimit * 100 * currencyRate;
            
                const hasSubscription = cart.items.some(
                    (item) => item.selling_plan_allocation
                );
            
                let shippingPercent = 0;
                let giftPercent = 0;
            
                if (hasSubscription) {
                    shippingPercent = 100;
                } else {
                    shippingPercent = (cartTotalPriceCents / limitShippingCents) * 100;
                    shippingPercent = Math.min(shippingPercent, 100);
                }
            
                if (cartTotalPriceCents >= limitGiftCents) {
                    giftPercent = 100;
                } else {
                    giftPercent =
                        ((cartTotalPriceCents - limitShippingCents) /
                            (limitGiftCents - limitShippingCents)) *
                        100;
                    giftPercent = Math.max(0, Math.min(giftPercent, 100));
                }
            
                const prevShippingPercent = parseFloat(
                    document.querySelector('.shipping-bar')?.dataset.prevPercent || 0
                );
                const prevGiftPercent = parseFloat(
                    document.querySelector('.gift-bar')?.dataset.prevPercent || 0
                );
            
                updateProgressBarsAndIcons(
                    shippingPercent,
                    giftPercent,
                    prevShippingPercent,
                    prevGiftPercent
                );
            
                const messageEl = document.querySelector('.cart-drawer__message-new');
                const defaultMsg = messageEl.querySelector('.cart__message__default-new');
                const successMsg = messageEl.querySelector('.cart__message__success-new');
            
                if (giftPercent >= 100) {
                    successMsg.textContent = decodeHTMLEntities(shippingGiftMessage);
                    successMsg.classList.remove('is-hidden');
                    defaultMsg.classList.add('is-hidden');
                } else if (shippingPercent >= 100) {
                    const leftToSpend = limitGiftCents - cartTotalPriceCents;
                    const leftToSpendFormatted = themeVendor.themeCurrency
                        .formatMoney(leftToSpend, moneyFormat)
                        .replace('.00', '')
                        .replace(',00', '');
                    defaultMsg.textContent = decodeHTMLEntities(freeGiftMessage.replace(
                        '||amount||',
                        leftToSpendFormatted
                    ));
                    defaultMsg.classList.remove('is-hidden');
                    successMsg.classList.add('is-hidden');
                } else {
                    const leftToSpend = limitShippingCents - cartTotalPriceCents;
                    const leftToSpendFormatted = themeVendor.themeCurrency
                        .formatMoney(leftToSpend, moneyFormat)
                        .replace('.00', '')
                        .replace(',00', '');
                    defaultMsg.textContent = decodeHTMLEntities(shippingMessage.replace(
                        '||amount||',
                        leftToSpendFormatted
                    ));
                    defaultMsg.classList.remove('is-hidden');
                    successMsg.classList.add('is-hidden');
                }
            
                messageEl.classList.toggle('shipping-achieved', shippingPercent >= 100);
                messageEl.classList.toggle('gift-achieved', giftPercent >= 100);
            
                const shippingBar = document.querySelector('.shipping-bar');
                if (shippingBar) {
                    shippingBar.dataset.prevPercent = shippingPercent;
                }
                const giftBar = document.querySelector('.gift-bar');
                if (giftBar) {
                    giftBar.dataset.prevPercent = giftPercent;
                }
            };


            const updateProgressBarsAndIcons = (
                shippingPercent,
                giftPercent,
                prevShippingPercent,
                prevGiftPercent
            ) => {
              // Animates the progress bars and icons
              const shippingBar = document.querySelector('.shipping-bar');
              const giftBar = document.querySelector('.gift-bar');
              const shippingIcon = document.querySelector('.shipping-icon .marker-icon');
              const giftIcon = document.querySelector('.gift-icon .marker-icon');
              
              const shippingSVG = document.querySelector('#shippingSvgUniqueId');
              const giftSVG = document.querySelector('#freeGiftSvgUniqueId');
              
              const giftBgPath = giftSVG.querySelector('#bgPath');
              const giftFgPath = giftSVG.querySelector('#fgPath');
              const giftShapePath = giftSVG.querySelector('#shapePath');
              
              const shippingBgPath = shippingSVG.querySelector('#bgPathIcon');
              const shippingFgPath = shippingSVG.querySelector('#fgPathIcon');
              const shippingShapePath = shippingSVG.querySelector('#shapePathIcon');
              const shippingSmallShapePath = shippingSVG.querySelector('#smallShapeIcon');

              const accentColor = '#7bacba';
              const defaultColor = '#e5e5e5';
          
              if ( shippingPercent > prevShippingPercent ||
                   giftPercent > prevGiftPercent
                ) {
                    if (shippingBar) {
                        shippingBar.style.width = shippingPercent + '%';

                        setTimeout(() => {
                            if (shippingPercent >= 100) {
                                shippingBgPath.style.fill = defaultColor;
                                shippingFgPath.style.fill = accentColor;
                                shippingShapePath.style.fill = defaultColor;
                                shippingSmallShapePath.style.fill = defaultColor;
                              
                              
                            } else {
                                shippingBgPath.style.fill = accentColor;
                                shippingFgPath.style.fill = defaultColor;
                                shippingShapePath.style.fill = accentColor;
                                shippingSmallShapePath.style.fill = accentColor;
                              
                            }
                        }, 300);
                    }

                    setTimeout(() => {
                        if (giftBar) {
                            giftBar.style.width = giftPercent + '%';

                            setTimeout(() => {
                                if (giftPercent >= 100) {
                                    giftBgPath.style.fill = defaultColor;
                                    giftFgPath.style.fill = accentColor;
                                    giftShapePath.style.fill = defaultColor;
                                } else {
                                    giftBgPath.style.fill = accentColor;
                                    giftFgPath.style.fill = defaultColor;
                                    giftShapePath.style.fill = accentColor;
                                }
                            }, 300);
                        }
                    }, 600);
                } else {
                    if (giftBar) {
                        if (giftPercent >= 100) {
                            giftBgPath.style.fill = defaultColor;
                            giftFgPath.style.fill = accentColor;
                            giftShapePath.style.fill = defaultColor;
                        } else {
                            giftBgPath.style.fill = accentColor;
                            giftFgPath.style.fill = defaultColor;
                            giftShapePath.style.fill = accentColor;
                        }

                        setTimeout(() => {
                            giftBar.style.width = giftPercent + '%';
                        }, 300);
                    }

                    setTimeout(() => {
                        if (shippingBar) {
                            if (shippingPercent >= 100) {
                                shippingBgPath.style.fill = defaultColor;
                                shippingFgPath.style.fill = accentColor;
                                shippingShapePath.style.fill = defaultColor;
                                shippingSmallShapePath.style.fill = defaultColor;
                            } else {
                                shippingBgPath.style.fill = accentColor;
                                shippingFgPath.style.fill = defaultColor;
                                shippingShapePath.style.fill = accentColor;
                                shippingSmallShapePath.style.fill = accentColor;
                            }

                            setTimeout(() => {
                                shippingBar.style.width = shippingPercent + '%';
                            }, 300);
                        }
                    }, 600);
                }
          };

            const checkGiftEligibilityWithCart = (cart) => {
                // Determines if the free gift should be added or removed
                cartTotalPrice = cart.total_price;
                let adjustedFreeGiftLimitCurrency = freeGiftLimitCurrency * currencyRate;
                const hasHolidayBox = cart.items.some((item) => item.product_title === "Gift Box");
                const isGiftInCart = cart.items.some(
                  (item) => item.id == freeGiftVariantId
                );
                const cartMessageElement = document.querySelector('.cart-drawer__message');
              
                if (hasHolidayBox && !isGiftInCart) {
                  cartMessageElement.style.display = 'flex';
                  return;
                } else if (hasHolidayBox && isGiftInCart) {
                  cartMessageElement.style.display = 'flex';
                  removeFreeGift();
                  return;
                } else {
                  cartMessageElement.style.display = 'none';
                }
                let isFreeGiftEligible =
                    adjustedFreeGiftLimitCurrency - cartTotalPrice < 0;

                if (isFreeGiftEligible) {
                    addFreeGift();
                } else {
                    removeFreeGift();
                }
            };

            const addFreeGift = () => {
              console.log('Adding Free Gift');
                // Automatically adds a free gift to the cart when the threshold is met
                if (isAddingFreeGift) {
                    return;
                }

                isAddingFreeGift = true;

                fetch('/cart.js')
                    .then((response) => response.json())
                    .then((cartData) => {
                        const isGiftInCart = cartData.items.some(
                            (item) => item.id == freeGiftVariantId
                        );

                        if (!isGiftInCart) {
                            console.log('Adding free gift...');
                            $.ajax({
                                url: '/cart/add.js',
                                type: 'POST',
                                data: {
                                    items: [
                                        {
                                            id: freeGiftVariantId,
                                            quantity: freeGiftQuantity,
                                        },
                                    ],
                                },
                                dataType: 'json',
                                success: function(data) {
                                    console.log('Free gift added:', data);
                                    document.dispatchEvent(new CustomEvent('updateCartDrawer'));
                                    setTimeout(() => {
                                        isAddingFreeGift = false;
                                    }, 2000);
                                },
                                error: function(jqXHR) {
                                    console.error('Error adding free gift:', jqXHR.responseJSON);
                                    isAddingFreeGift = false;
                                },
                            });
                        } else {
                            console.log('Free gift is already in the cart.');
                            isAddingFreeGift = false;
                        }
                    })
                    .catch((error) => {
                        console.error('Error checking cart for free gift:', error);
                        isAddingFreeGift = false;
                    });
            };

            const removeFreeGift = () => {
                // Removes the free gift if the cart total drops below the threshold
                fetch('/cart.js')
                    .then((response) => response.json())
                    .then((cartData) => {
                        const giftItem = cartData.items.find(
                            (item) => item.id == freeGiftVariantId
                        );

                        if (giftItem) {
                            console.log('Removing free gift...');
                            $.ajax({
                                url: '/cart/change.js',
                                type: 'POST',
                                data: {
                                    id: freeGiftVariantId,
                                    quantity: 0,
                                },
                                dataType: 'json',
                                success: function(data) {
                                    console.log('Free gift removed:', data);
                                    document.dispatchEvent(new CustomEvent('updateCartDrawer'));
                                },
                                error: function(jqXHR) {
                                    console.error('Error removing free gift:', jqXHR.responseJSON);
                                },
                            });
                        } else {
                            console.log('No free gift found in the cart.');
                        }
                    })
                    .catch((error) =>
                        console.error('Error checking cart for free gift:', error)
                    );
            };

            // Set up event listeners for updating cart data
            const eventsToUpdateCartData = [
                'theme:cart:open',
                'theme:cart:added',
                'theme:cart:change',
                'cart:updated',
            ];
            eventsToUpdateCartData.forEach((event) => {
                document.addEventListener(event, updateCartData);
            });

            // Initial check on page load
            updateCartData();
        }

        // Read More initialization
        const drawerToggles = document.querySelectorAll('[data-drawer-toggle-custom]');
        const drawerOverlays = document.querySelectorAll('.drawer__overlay');

        drawerToggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                const drawerId = toggle.getAttribute('aria-controls');
                const drawer = document.getElementById(drawerId);

                if (drawer) {
                    const isHidden = drawer.getAttribute('aria-hidden') === 'true';
                    drawer.setAttribute('aria-hidden', !isHidden);

                    if (isHidden) {
                        drawer.classList.add('is-open');
                        document.body.classList.add('js-drawer-open');
                        lockScrollReadMore();
                    } else {
                        drawer.classList.remove('is-open');
                        document.body.classList.remove('js-drawer-open');
                        unlockScrollReadMore();
                    }
                }
            });
        });

        drawerOverlays.forEach((overlay) => {
            overlay.addEventListener('click', () => {
                const drawer = document.querySelector('.product__popup.drawer.is-open[data-drawer-custom]');
                if (drawer) {
                    drawer.setAttribute('aria-hidden', 'true');
                    drawer.classList.remove('is-open');
                    document.body.classList.remove('js-drawer-open');
                    unlockScrollReadMore();
                }
            });
        });

        // Upsell Cart initialization
        const upsellProduct = document.querySelector('.cdk-upsell-product.upsell-product');
        const upsellForm = document.querySelector('form[data-upsell-selector="upsell_additional_enabled"], form[data-upsell-selector="upsell_enabled"]');

        if (upsellProduct && upsellForm) {
            const addToCartButton = upsellForm.querySelector('.MAINBUTTON[data-add-to-cart]');
            addToCartButton.setAttribute('data-upsell-drawer-click', 'false');
            addToCartButton.addEventListener('click', (event) => {
                const skipUpsell = addToCartButton.getAttribute('data-skip-upsell') === 'true';
                if (!skipUpsell && upsellForm && addToCartButton.getAttribute('data-upsell-drawer-click') === 'false') {
                    event.preventDefault();
                    event.stopPropagation();
                    if (upsellProduct) {
                        upsellProduct.classList.add('is-open');
                    }
                    lockScrollUpsell();
                } else {
                    addToCartButton.setAttribute('data-upsell-drawer-click', 'false');
                }
            });

            const upsellCase = upsellForm.getAttribute('data-upsell-selector');
            const upsellCloseButton = document.querySelector('.cart-drawer__close.upsell-close');
            const upsellButton = document.querySelector('.addUpsell_product');
            const normalButton = document.querySelector('.addNormal_product');

            if (upsellCloseButton && upsellForm) {
                upsellCloseButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    addToCartButton.setAttribute('data-upsell-drawer-click', true);
                    addToCartButton.click();
                    upsellProduct.classList.remove('is-open');
                    unlockScrollUpsell();
                });
            }

           drawerOverlays.forEach((overlay) => {
                overlay.addEventListener('click', () => {
                    if (upsellProduct.classList.contains('is-open')) {
                        addToCartButton.setAttribute('data-upsell-drawer-click', true);
                        addToCartButton.click();
                        upsellProduct.classList.remove('is-open');
                        unlockScrollUpsell();
                    }
                });
            });

            if (upsellButton && upsellForm) {
                upsellButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    const index = upsellForm.getAttribute('data-selected-item-index');
                    getBundleProductData(index, upsellCase, addToCartButton);
                    upsellProduct.classList.remove('is-open');
                    unlockScrollUpsell();
                });
            }

            if (normalButton && upsellForm) {
                normalButton.addEventListener('click', (event) => {
                    event.preventDefault();
                    addToCartButton.setAttribute('data-upsell-drawer-click', true);
                    addToCartButton.click();
                    upsellProduct.classList.remove('is-open');
                    unlockScrollUpsell();
                });
            }
        }

        // Subscription Selector initialization
        const initializeWidgets = () => {
            document.querySelectorAll('.subscription-widget').forEach((widget) => {
                const widgetId = widget.getAttribute('data-widget-id');
                initSubscriptionWidget(widgetId);
            });
        };

        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('pswp__zoom-wrap')) {
                            const subscriptionWidgets = node.querySelectorAll('.subscription-widget');
                            subscriptionWidgets.forEach((subscriptionWidget) => {
                                if (subscriptionWidget) {
                                    initializeWidgets();
                                }
                            })

                        } else if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('subscription-widget')) {
                            initializeWidgets();
                        }
                    });
                }
            });
        });

        const observeConfig = {
            childList: true,
            subtree: true
        };
        observer.observe(document.body, observeConfig);
        initializeWidgets();

        // CartDrawer Upgrade To Subscription
        if (window.location.href.includes('/cart')) {
            let subscriptionButtons = document.querySelectorAll('.subscription-button');
            subscriptionButtons.forEach(function(button) {
                if (button.getAttribute('data-click-added') === null) {
                    button.setAttribute('data-click-added', '');
                    button.addEventListener('click', function(e) {
                        e.preventDefault();
                        let optionsContainer = this.nextElementSibling;
                        let selectElement = optionsContainer.querySelector('.subscription-select');
                        optionsContainer.style.display = 'block';
                        selectElement.style.display = 'block';
                        this.style.display = 'none';
                        this.classList.add('is-loading');
                        selectElement.showPicker();
                    });
                }
            });

            let subscriptionSelects = document.querySelectorAll('.subscription-select');
            subscriptionSelects.forEach(function(select) {
                select.setAttribute('data-initial-value', select.value);

                select.addEventListener('change', function() {
                    let initialValue = this.getAttribute('data-initial-value');
                    if (this.value !== initialValue) {
                        let cartItemID = this.closest('.upgrade-to-subscription').getAttribute('data-line-item-id');
                        let selectedPlanID = this.value;
                        let variantId = this.querySelector('option:checked').getAttribute('data-variant-id');
                        fetch('/cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                id: cartItemID,
                                quantity: 0
                            }),
                        })
                        .then(response => response.json())
                        .then(data => {
                            fetch('/cart/add.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    items: [{
                                        id: variantId,
                                        quantity: 1,
                                        selling_plan: selectedPlanID
                                    }]
                                }),
                            })
                            .then(response => response.json())
                            .then(data => {
                                location.reload();
                            })
                            .catch(error => {
                                console.error('Error adding item to cart:', error);
                            });
                        })
                        .catch(error => {
                            console.error('Error updating cart:', error);
                        });

                        this.style.display = 'none';
                        this.closest('.upgrade-to-subscription').querySelector('.subscription-button').style.display = 'block';
                        this.closest('.subscription-options-container').style.display = 'none';

                        this.setAttribute('data-initial-value', this.value);
                    }
                });
            });
        }

    });

    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
})();